import React, { useState } from 'react';
import InputWithKeyboard from "../../formElements/InputWithKeyboard";
import Translate from "localization/Translate";
import Button from "../../buttons/Button";
import {validateEmail} from "../../redux/dto/customer";
import Image from "../../theme/Image";

export default function ({onAccept, onCancel}) {
    let [email, setEmail] = useState('');

    let [validationError, setValidationError] = useState(false);
    let validationErrorDisplay;
    if(validationError !== false){
        validationErrorDisplay = (
            <span
                style={{
                    marginLeft: '30%'
                }}
                className={'errorMessage'}
            >
                {validationError}
            </span>
        );
    }
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column'
        }}>
            <div style={{
                marginTop: '3.57rem',
                marginBottom: '3.57rem',
                alignSelf: 'center'
            }}>
                <Image image={"dialogue"} alt={'dialogue'} style={{
                    float: 'left'
                }}/>
                <h1 style={{
                    float: 'left',
                    marginLeft: '2.86rem'
                }} className={'capitalizeFirst'}><Translate id={'please type your email'}/></h1>
            </div>
            <InputWithKeyboard
                placeholder={'E-MAIL'}
                onInputChange={(value) => {
                    setEmail(value);
                }}
                onDone={(value) => {}}
                style={{
                    width: '40%',
                    alignSelf: 'center'
                }}
            />
            {validationErrorDisplay}
            <div style={{
                marginTop: '5rem',
                marginRight: '2.86rem',
                width: '40%',
                alignSelf: 'center'
            }}>
                <Button
                    type="button"
                    className={"largeButton grayButton"}
                    name={<Translate id={"cancel"}/>}
                    arrow="right"
                    flencheClass={"flencheSmallRightBottom grayFlenche"}
                    onClick={e => {
                        onCancel();
                    }}
                />
                <Button
                    type="button"
                    className={"largeButton blueButton"}
                    name={<Translate id={"accept"}/>}
                    flencheClass={"flencheRight transparentFlenche"}
                    arrow="right"
                    style={{
                        float: 'right'
                    }}
                    onClick={e => {
                        if(validateEmail(email)){
                            onAccept(email);
                        }else{
                            setValidationError(<Translate id={'emailValidationError'}/>)
                        }
                    }}
                />
            </div>
        </div>
    );
}